import React from "react";
import { useStats } from "@/lib/queries";
import { Package, Flame, Bell, Eye } from "lucide-react";

function Stat({ label, value, icon: Icon, accent }) {
  return (
    <div className="bg-[#0d0d0d] border border-[#262626] p-3 flex items-center gap-3 rounded-sm">
      <div
        className="w-9 h-9 flex items-center justify-center border rounded-sm shrink-0"
        style={{ borderColor: `${accent}55`, color: accent, backgroundColor: `${accent}10` }}
      >
        <Icon className="w-4 h-4" />
      </div>
      <div>
        <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#737373]">
          {label}
        </div>
        <div className="text-xl font-mono font-bold text-white leading-tight">
          {value ?? "—"}
        </div>
      </div>
    </div>
  );
}

export default function StatsBar() {
  const { data: stats } = useStats();
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="stats-bar">
      <Stat label="Listings tracked" value={stats?.listings_total} icon={Package} accent="#3B82F6" />
      <Stat label="In stock" value={stats?.in_stock} icon={Eye} accent="#22C55E" />
      <Stat label="Hot deals" value={stats?.hot_deals} icon={Flame} accent="#EAB308" />
      <Stat label="Alerts" value={stats?.alerts_total} icon={Bell} accent="#EF4444" />
    </div>
  );
}
